import { Box } from '@mui/material';
import { ReactComponent as BolLogo } from '../styles/svg/bol.svg';
import { ReactComponent as CcvshopLogo } from '../styles/svg/ccvshop.svg';
import { ReactComponent as KauflandLogo } from '../styles/svg/kaufland.svg';
import { ReactComponent as LightspeedLogo } from '../styles/svg/lightspeed.svg';
import { ReactComponent as ApiLogo } from '../styles/svg/pin.svg';
import { ReactComponent as MagentoLogo } from '../styles/svg/magento.svg';
import { ReactComponent as ShopifyLogo } from '../styles/svg/shopify.svg';
import { ReactComponent as WooCommerceLogo } from '../styles/svg/woocommerce.svg';
import { ReactComponent as EtailizeLogo } from '../styles/svg/etailize.svg';
import { ReactComponent as ProductflowLogo } from '../styles/svg/productflow.svg';
import { ReactComponent as MiraklLogo } from '../styles/svg/mirakl.svg';
import { ReactComponent as PlugAndPayLogo } from '../styles/svg/plugandpay.svg';
import { ReactComponent as PrestashopLogo } from '../styles/svg/prestashop.svg';
import { ReactComponent as ShopwareLogo } from '../styles/svg/shopware.svg';
import { ReactComponent as TikTokLogo } from '../styles/svg/tiktok.svg';
import { QuestionMarkOutlined } from "@mui/icons-material";

//Market places
import { ReactComponent as Alltricks } from '../styles/svg/marketplace/alltricks-app-icon.svg';
import { ReactComponent as Amazon } from '../styles/svg/marketplace/amazon-app-icon.svg';
import { ReactComponent as Anwb } from '../styles/svg/marketplace/anwb-app-icon.svg';
import { ReactComponent as Autodoc } from '../styles/svg/marketplace/autodoc-app-icon.svg';
import { ReactComponent as BigBang } from '../styles/svg/marketplace/bigbang-app-icon.svg';
import { ReactComponent as Blokker } from '../styles/svg/marketplace/blokker-app-icon.svg';
import { ReactComponent as Bol } from '../styles/svg/marketplace/bol-app-icon.svg';
import { ReactComponent as Brico } from '../styles/svg/marketplace/brico-app-icon.svg';
import { ReactComponent as Carrefour } from '../styles/svg/marketplace/carrefour-app-icon.svg';
import { ReactComponent as Castorama } from '../styles/svg/marketplace/castorama-app-icon.svg';
import { ReactComponent as Conforama } from '../styles/svg/marketplace/conforama-app-icon.svg';
import { ReactComponent as Conrad } from '../styles/svg/marketplace/conrad-app-icon.svg';
import { ReactComponent as DeBijenkorf } from '../styles/svg/marketplace/debijenkorf-app-icon.svg';
import { ReactComponent as Decathlon } from '../styles/svg/marketplace/decathlon-app-icon.svg';
import { ReactComponent as Douglas } from '../styles/svg/marketplace/douglas-app-icon.svg';
import { ReactComponent as Eleclerc } from '../styles/svg/marketplace/eleclerc-app-icon.svg';
import { ReactComponent as Eprice } from '../styles/svg/marketplace/eprice-app-icon.svg';
import { ReactComponent as Fonq } from '../styles/svg/marketplace/fonq-app-icon.svg';
import { ReactComponent as Home24 } from '../styles/svg/marketplace/home24-app-icon.svg';
import { ReactComponent as Hornbach } from '../styles/svg/marketplace/hornbach-app-icon.svg';
import { ReactComponent as Inno } from '../styles/svg/marketplace/inno-app-icon.svg';
import { ReactComponent as Jardiland } from '../styles/svg/marketplace/jardiland-app-icon.svg';
import { ReactComponent as Kaufland } from '../styles/svg/marketplace/kaufland-app-icon.svg';
import { ReactComponent as Kleertjes } from '../styles/svg/marketplace/kleertjespuntcom-app-icon.svg';
import { ReactComponent as Kruidvat } from '../styles/svg/marketplace/kruidvat-app-icon.svg';
import { ReactComponent as Laposte } from '../styles/svg/marketplace/laposte-app-icon.svg';
import { ReactComponent as Leenbakker } from '../styles/svg/marketplace/leenbakker-app-icon.svg';
import { ReactComponent as LeroyMerlin } from '../styles/svg/marketplace/leroymerlin-app-icon.svg';
import { ReactComponent as Mdm } from '../styles/svg/marketplace/mdm-app-icon.svg';
import { ReactComponent as Mediamarktsaturn } from '../styles/svg/marketplace/mediamarktsaturn-app-icon.svg';
import { ReactComponent as Metromakro } from '../styles/svg/marketplace/metromakro-app-icon.svg';
import { ReactComponent as Obelink } from '../styles/svg/marketplace/obelink-app-icon.svg';
import { ReactComponent as Pccomponentes } from '../styles/svg/marketplace/pccomponentes-app-icon.svg';
import { ReactComponent as Pixmania } from '../styles/svg/marketplace/pixmania-app-icon.svg';
import { ReactComponent as Praxis } from '../styles/svg/marketplace/praxis-app-icon.svg';
import { ReactComponent as Rueducommerce } from '../styles/svg/marketplace/rueducommerce-app-icon.svg';
import { ReactComponent as Secretsales } from '../styles/svg/marketplace/secretsales-app-icon.svg';
import { ReactComponent as Shopapotheke } from '../styles/svg/marketplace/shopapotheke-app-icon.svg';
import { ReactComponent as Venteunique } from '../styles/svg/marketplace/venteunique-app-icon.svg';
import { ReactComponent as Vidaxl } from '../styles/svg/marketplace/vidaxl-app-icon.svg';
import { ReactComponent as Vtwonen } from '../styles/svg/marketplace/vtwonen-app-icon.svg';
import { ReactComponent as Worten } from '../styles/svg/marketplace/worten-app-icon.svg';
import { ReactComponent as Yoox } from '../styles/svg/marketplace/yoox-app-icon.svg';

import { ReactComponent as DhlLogo } from '../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../styles/svg/dpd.svg';
import { ReactComponent as PostNLLogo } from '../styles/svg/postnl.svg';
import { ReactComponent as ParcelLogo } from '../styles/svg/parcel.svg';
import { ReactComponent as CirroLogo } from '../styles/svg/cirro.svg';
import { ReactComponent as SendcloudLogo } from '../styles/svg/sendcloud.svg';
import { ReactComponent as InnosendLogo } from '../styles/svg/innosend.svg';
import { ReactComponent as UpsLogo } from '../styles/svg/ups.svg';
import { ReactComponent as IntrapostLogo } from '../styles/svg/intrapost.svg';
import { ReactComponent as MyparcelLogo } from '../styles/svg/myparcel.svg';
import { ReactComponent as GlsLogo } from '../styles/svg/gls.svg';
import { ReactComponent as TrunkrsLogo } from '../styles/svg/trunkrs.svg';
import { ReactComponent as CycloonLogo } from '../styles/svg/cycloon.svg';
import { ReactComponent as MyparcelcomLogo } from '../styles/svg/myparcelcom.svg';
import { ReactComponent as AmpereLogo } from '../styles/svg/ampere.svg';
import { ReactComponent as HstLogo } from '../styles/svg/hst.svg';
import { ReactComponent as PredikoLogo } from '../styles/svg/prediko.svg';
import { ReactComponent as ReturnlessLogo } from '../styles/svg/returnless.svg';
import { ReactComponent as OutlookLogo } from '../styles/svg/outlook.svg';
import { ReactComponent as ZinepsLogo } from '../styles/svg/zineps.svg';
import { ReactComponent as VinologixLogo } from '../styles/svg/vinologix.svg';
import { ReactComponent as WegrowLogo } from '../styles/svg/wegrow.svg';
import { ReactComponent as BoombaLogo } from '../styles/svg/boomba.svg';

import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import PublicIcon from '@mui/icons-material/Public';

import { generateColorFromTitle, generateIconColorFromTitle } from "../components/theme/TabView3/IconColorGenerator";

export const marketPlaceAppIconsMap = [
    { name: 'alltricks', Icon: Alltricks },
    { name: 'amazon', Icon: Amazon },
    { name: 'anwb', Icon: Anwb },
    { name: 'autodoc', Icon: Autodoc },
    { name: 'bigbang', Icon: BigBang },
    { name: 'blokker', Icon: Blokker },
    { name: 'bol', Icon: Bol },
    { name: 'brico', Icon: Brico },
    { name: 'carrefour', Icon: Carrefour },
    { name: 'castorama', Icon: Castorama },
    { name: 'conforama', Icon: Conforama },
    { name: 'conrad', Icon: Conrad },
    { name: 'debijenkorf', Icon: DeBijenkorf },
    { name: 'decathlon', Icon: Decathlon },
    { name: 'douglas', Icon: Douglas },
    { name: 'eleclerc', Icon: Eleclerc },
    { name: 'eprice', Icon: Eprice },
    { name: 'fonq', Icon: Fonq },
    { name: 'home24', Icon: Home24 },
    { name: 'hornbach', Icon: Hornbach },
    { name: 'inno', Icon: Inno },
    { name: 'jardiland', Icon: Jardiland },
    { name: 'kaufland', Icon: Kaufland },
    { name: 'kleertjes', Icon: Kleertjes },
    { name: 'kruidvat', Icon: Kruidvat },
    { name: 'laposte', Icon: Laposte },
    { name: 'leenbakker', Icon: Leenbakker },
    { name: 'leroymerlin', Icon: LeroyMerlin },
    { name: 'mdm', Icon: Mdm },
    { name: 'mediamarkt', Icon: Mediamarktsaturn },
    { name: 'metromakro', Icon: Metromakro },
    { name: 'makro', Icon: Metromakro },
    { name: 'obelink', Icon: Obelink },
    { name: 'pccomponentes', Icon: Pccomponentes },
    { name: 'pixmania', Icon: Pixmania },
    { name: 'praxis', Icon: Praxis },
    { name: 'rueducommerce', Icon: Rueducommerce },
    { name: 'secretsales', Icon: Secretsales },
    { name: 'shopapotheke', Icon: Shopapotheke },
    { name: 'venteunique', Icon: Venteunique },
    { name: 'vidaxl', Icon: Vidaxl },
    { name: 'vtwonen', Icon: Vtwonen },
    { name: 'worten', Icon: Worten },
    { name: 'yoox', Icon: Yoox },
  ];

export const normalizeMarketPlaceName = str => str?.toLowerCase().replace(/[\s\.\-_]/g, '') || '';

export const getWebshopLogo = (webshopType,theming,name = undefined) => {
    let logo;

    switch (webshopType) {
        case "magento":
            logo = <MagentoLogo width={30} height={30} />;
            break;
        case "shopify":
            logo = <ShopifyLogo width={30} height={30} />;
            break;
        case "woocommerce":
            logo = <WooCommerceLogo width={30} height={30} />;
            break;
        case "bol":
            logo = <BolLogo width={30} height={30} />;
            break;
        case "ccvshop":
            logo = <CcvshopLogo width={30} height={30} />;
            break;
        case "kaufland":
            logo = <KauflandLogo width={30} height={30} />;
            break;
        case "boombabamboo":
            logo = <BoombaLogo width={30} height={30} />;
            break;
        case "lightspeed":
        case "lightspeed_ecom":
            logo = <LightspeedLogo width={30} height={30} />;
            break;
        case "api":
            logo = <ApiLogo width={30} height={30} />;
            break;
        case "etailize":
            if(name !== undefined) {
                const normName = normalizeMarketPlaceName(name).toLowerCase();
                const match = marketPlaceAppIconsMap.find(icon => normName.includes(icon.name));
                const {theme,colors} = theming;
                if(match) {
                    let color = null;
                    logo = <Box
                            sx={{
                                borderRadius:4,
                                height:32,
                                overflow:'hidden',
                                width:32,
                                background:theme.palette.mode === "dark" ? colors.txt["primary"] : null,
                            }}
                        >
                            <match.Icon width={32} height={32} />
                        </Box>;
                } else {
                    logo = <EtailizeLogo width={30} height={30} />;
                }
            }else{
                logo = <EtailizeLogo width={30} height={30} />;
            }
            break;
        case "mirakl":
            logo = <MiraklLogo width={30} height={30} />;
            break;
        case "plugandpay":
            logo = <PlugAndPayLogo width={30} height={30} />;
            break;
        case "prestashop":
            logo = <PrestashopLogo width={30} height={30} />;
            break;
        case "shopware6":
            logo = <ShopwareLogo width={30} height={30} />;
            break;
        case "amazon_stockhub":
            logo = <Amazon width={30} height={30} />;
            break;
        case "tiktokshop":
            logo = <TikTokLogo width={30} height={30} />;
            break;
        case "other":
            logo = <QuestionMarkOutlined width={30} height={30} />;
            break;
        default:
            logo = null;
    }

    return <Box>{logo}</Box>;
};

export const getWebshopLogoNoSize = (webshopType,name=undefined) => {
    let logo;

    switch (webshopType) {
        case "magento":
            logo = <MagentoLogo width={48} height={48} />;
            break;
        case "shopify":
            logo = <ShopifyLogo width={48} height={48} />;
            break;
        case "woocommerce":
            logo = <WooCommerceLogo width={48} height={48} />;
            break;
        case "bol":
            logo = <BolLogo width={48} height={48} />;
            break;
        case "ccvshop":
            logo = <CcvshopLogo width={48} height={48} />;
            break;
        case "kaufland":
            logo = <KauflandLogo width={48} height={48} />;
            break;
        case "boombabamboo":
            logo = <BoombaLogo width={48} height={48} />;
            break;
        case "lightspeed":
        case "lightspeed_ecom":
            logo = <LightspeedLogo width={48} height={48} />;
            break;
        case "api":
            logo = <ApiLogo width={48} height={48} />;
            break;
        case "etailize":
            if(name !== undefined) {
                const normName = normalizeMarketPlaceName(name).toLowerCase();
                const match = marketPlaceAppIconsMap.find(icon => normName.includes(icon.name));
                if(match) {
                    logo = <match.Icon width={32} height={32} />;
                } else {
                    logo = <EtailizeLogo width={30} height={30} />;
                }
            } else{
                logo = <EtailizeLogo width={48} height={48} />;
            }
            break;
        case "plugandpay":
            logo = <PlugAndPayLogo width={48} height={48} />;
            break;
        case "prestashop":
            logo = <PrestashopLogo width={48} height={48} />;
            break;
        case "shopware6":
            logo = <ShopwareLogo width={48} height={48} />;
            break;
        case "amazon_stockhub":
            logo = <Amazon width={48} height={48} />;
            break;
        case "tiktokshop":
            logo = <TikTokLogo width={48} height={48} />;
            break;
        case "other":
            logo = <QuestionMarkOutlined width={48} height={48} />;
            break;
        default:
            logo = null;
    }

    return logo;
};

export const getIntegratorLogo = (webshopType) => {
    let logo;

    switch (webshopType) {
        case "etailize":
            logo = <EtailizeLogo width={30} height={30} />;
            break;
        case "productflow":
            logo = <ProductflowLogo width={30} height={30} />;
            break;
        default:
            logo = null;
    }

    return <Box>{logo}</Box>;
};

export const getShipperLogo = (shipperType) => {
    let logo;
    switch(shipperType) {
        case "postnl":
            logo = <PostNLLogo width={32} height={32}/>;
            break;
        case "dhl":
            logo = <DhlLogo width={32} height={32}/>;
            break;
        case "dpd":
            logo = <DpdLogo width={32} height={32}/>;
            break;
        case "parcel":
            logo = <ParcelLogo width={32} height={32}/>;
            break;
        case "cirro":
            logo = <CirroLogo width={32} height={32}/>;
            break;
        case "sendcloud":
            logo = <SendcloudLogo width={32} height={32}/>;
            break;
        case "innosend":
        case "innosendv2":
            logo = <InnosendLogo width={32} height={32}/>;
            break;
        case "ups":
            logo = <UpsLogo width={32} height={32}/>;
            break;
        case "dhlgermany":
            logo = <DhlGermanyLogo width={32} height={32}/>;
            break;
        case "intrapost":
            logo = <IntrapostLogo width={32} height={32}/>;
            break;
        case "myparcel":
            logo = <MyparcelLogo width={32} height={32}/>;
            break;
        case "myparcelcom":
            logo = <MyparcelcomLogo width={32} height={32}/>;
            break;
        case "ampere":
            logo = <AmpereLogo width={32} height={32}/>;
            break;
        case "gls":
            logo = <GlsLogo width={32} height={32}/>;
            break;
        case "trunkrs":
            logo = <TrunkrsLogo width={32} height={32}/>;
            break;
        case "cycloon":
            logo = <CycloonLogo width={32} height={32}/>;
            break;
        case "hst":
            logo = <HstLogo width={32} height={32}/>;
            break;
        case "zineps":
            logo = <ZinepsLogo width={32} height={32}/>;
            break;
        case "vinologix":
            logo = <VinologixLogo width={32} height={32}/>;
            break;
        case "wegrow":
            logo = <WegrowLogo width={32} height={32}/>;
            break;
        case "bol":
            logo = <BolLogo width={32} height={32}/>;
            break;
        case "other":
            logo = <AltRouteOutlinedIcon width={32} height={32}/>;
            break;
    }
    return <Box sx={{display:'flex',alignItems:'center',justifyContent:'center'}}>{logo}</Box>
}

export const LOG_ACTION_ICON_MAP = {
    default: CircleOutlinedIcon,
    create: AddCircleOutlineIcon,
    read: VisibilityOutlinedIcon,
    update: EditOutlinedIcon,
    delete: DeleteOutlineIcon,
    import: FileUploadOutlinedIcon,
    shipment: LocalShippingOutlinedIcon,
    shipmentconfirmed: CheckCircleOutlineIcon,
    shipmentmailed: MailOutlineIcon,
    provisionalshipment: ScheduleOutlinedIcon,
    completed: DoneAllIcon,
    picking: ShoppingCartOutlinedIcon,
    error: ErrorOutlineIcon,
    warning: WarningAmberIcon,
    info: InfoOutlinedIcon,
    supportticket: SupportAgentOutlinedIcon,
};

export const LogActionIcon = ({ action }) => {
    if (!action) return null;
    const key = action.toLowerCase();
    const IconComponent = LOG_ACTION_ICON_MAP[key] ?? LOG_ACTION_ICON_MAP.default;
    return <IconComponent sx={{ fontSize: 16 }} />;
};

export const LogActionBadge = ({ action, mode }) => {
    if (!action) return null;
    const color = generateIconColorFromTitle(action, mode);
    const bg = generateColorFromTitle(action, mode, 93);
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 32,
                height: 32,
                borderRadius: 4,
                background: bg,
                color: color,
                flexShrink: 0,
            }}
        >
            <LogActionIcon action={action} />
        </Box>
    );
};

export const getExternalChannelLogo = (channelType) => {
    let logo;

    switch(channelType) {
        case "prediko":
            logo = <PredikoLogo width={48} height={48}/>;
            break;
        case "returnless":
            logo = <ReturnlessLogo width={48} height={48}/>;
            break;
        case "zonos":
            logo = <PublicIcon sx={{ width: 48, height: 48 }} />;
            break;
        case "outlook":
            logo = <OutlookLogo width={48} height={48}/>;
            break;
        case "smtpimap":
            logo = <MailOutlineIcon sx={{ width: 48, height: 48 }} />;
            break;
        case "ampere":
            logo = <AmpereLogo width={48} height={48}/>;
            break;
        default:
            logo = <QuestionMarkOutlined width={48} height={48}/>;
    }

    return logo;
}